/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { MultipleAuthorTemplate } from "../multi-author";
import { getAuthorNameKeyword, getStoryPubKeyword } from "../utils";

import "./hero-priority-multi-author.m.css";

export function HeroPriorityMultiAuthorTemplate(props) {
  const photoPriorityPropsObj = Object.assign({}, props, {
    authorNameKeyword: getAuthorNameKeyword(),
    storyPubKeyword: getStoryPubKeyword(),
    hideImage: true
  });

  return (
    <div styleName="hero-priority">
      <MultipleAuthorTemplate {...photoPriorityPropsObj} />
    </div>
  );
}
